<child-header title="Confirm Software Subscription Purchase" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content>
  <div id="divTenantAssociationPopup" class="reveal small reveal-modal" data-reveal data-close-on-click="false"
  data-close-on-esc="false">

  <div id="tenant_details" class="reveal-content">
    <h3>
      TENANT ASSOCIATION PENDING
    </h3>
    <div id="tenant_details">
      <div style="padding-bottom: 20px;">
        A new Microsoft Online Tenant association has been requested via the Dicker Data system. Below are the tenant
        details for your records.
      </div>
      <div>
        <table class="dark" cellpadding="0" cellspacing="0"
          style="width: 100%; border-spacing: 0; border-collapse: collapse;">
          <tr>
            <td>
              Tenant ID
            </td>
            <td>
              <label id="TenantID">{{ data?.tenantId }}</label>
            </td>
          </tr>
          <tr>
            <td>
              Company Name
            </td>
            <td>
              <label id="CompanyName">{{ data?.companyName }}</label>
            </td>
          </tr>
          <tr>
            <td>
              Tenant Domain
            </td>
            <td>
              <label id="TenantDomain">{{ data?.tenantDomain }}</label>
            </td>
          </tr>
          <tr>
            <td>
              Email
            </td>
            <td>
              <label id="TenantEmail">{{ data?.tenantEmail }}</label>
            </td>
          </tr>
        </table>
      </div>
      <div style="padding: 20px 0 20px 0;">
        To get started using the features of this Microsoft Online Tenant login to either of the Microsoft Management
        Portals below.
        <br />
        <br />
        <div style="color: blue">
          <a href="https://portal.office.com" target="_blank">https://portal.office.com</a>
          <br>
          <a href="https://portal.office.com" target="_blank">https://portal.azure.com</a>
        </div>
      </div>
      <div style="padding: 0 0 20px 0;">
        As a Microsoft CSP reseller, it is your responsibility to provide your end user with a copy of the Microsoft
        Customer Agreement (MCA) terms and conditions.
        <br />
        <br />
        <a style="color: blue;" href="https://creative.dickerdata.com.au/2017/12-Dec/Microsoft/MCA2017Agr_Asia.pdf"
          target="_blank">Microsoft Customer Agreement</a>
      </div>
    </div>
  </div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="button button-red button-large continue" (click)="onNoClick()">OK</button>
</div>
